import { Button, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { createAnalyticsExcel } from "@/pages/dashboard/utils/createExcel";
import { useGetExportAnalyticsMutation } from "@/app/features/analytics/analyticsApiSlice";
const ExportDashboardAnalyticsButton = ({
  startDate,
  endDate,
  selectedState,
}) => {
  const [getExportAnalytics, { isLoading, isError }] =
    useGetExportAnalyticsMutation();

  const handleCreateAnalyticsExcel = async () => {
    // createAnalyticsExcel(dashboardData);
    try {
      const { data } = await getExportAnalytics({
        startDate,
        endDate,
        state: selectedState === "All" ? "" : selectedState,
      });

      const {
        make,
        model,
        grade,
        sponsoredViews,
        sponsored,
        advertisementClicks,
        advertisementViews,
        financeClicks,
      } = data.data;

      createAnalyticsExcel(
        {
          make,
          model,
          grade,
          sponsoredViews,
          sponsored,
          advertisementClicks,
          advertisementViews,
          financeClicks,
        },
        startDate,
        endDate,
        selectedState
      );
    } catch (error) {
      console.log(error);
    }
  };

  if (isError) {
    return <Typography variant="h3">Something went wrong</Typography>;
  }

  return (
    <Button
      startIcon={<FileDownloadIcon />}
      variant="contained"
      onClick={handleCreateAnalyticsExcel}
      disabled={isLoading}
    >
      {isLoading ? "Exporting" : "Export"}
    </Button>
  );
};

export default ExportDashboardAnalyticsButton;
